import { ref } from '../config/firebase';

export function fetchCompatibilityMapping() {
    return ref.child('WEB_API_COMPATIBILITY').once('value').then((snapshot) => {
        const compatibilityPackages = snapshot.val() || {};

        let compatibilityMappings = {
            apis: compatibilityPackages['APIS'],
            commonApis: compatibilityPackages['commonAPIS'],
            consoleSpecificApis: compatibilityPackages['consoleSpecificAPIS'],
        };

        return compatibilityMappings;
    });
}



// WEBPACK FOOTER //
// ./src/firebase/compatibility.js